import React from 'react';
import Styled from './DropdownControl.style';
import { DropdownControlProps } from '../../interfaces';
import { useTranslation } from 'react-i18next';
const DropdownControl: React.FC<DropdownControlProps> = (props) => {
  const {
    answerKey,
    value,
    defaultValue,
    options,
    disabled,
    updateAnswerKey = () => void 0,
  } = props;

  const currentValue = value ?? defaultValue ?? '';
  const [t] = useTranslation('common');
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    updateAnswerKey(answerKey, e.target.value);
  };

  return (
    <Styled.Wrapper>
      <Styled.Select
        value={currentValue}
        onChange={handleChange}
        disabled={disabled}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.value === ''}
            hidden={option.value === ''}
          >
            {t(option.label)}
          </option>
        ))}
      </Styled.Select>
    </Styled.Wrapper>
  );
};

export default DropdownControl;
